module.exports = __webpack_public_path__ + "static/media/companyLogo5.8cda3b11.png";